<template>
    <a
        :class="itemClass"
        :href="redirect_uri || '#'"
        @click="!isClickable && $event.preventDefault()"
    >
        <CompassIcon :icon="icon" />
        <span>
            {{ label }}
        </span>
        <CompassFlag v-if="!available" :label="$t.__('common.labels.soon')" size="small" />
    </a>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        available: {
            type: Boolean,
            default: false,
        },
        completed: {
            type: Boolean,
            default: false,
        },
        redirect_uri: {
            type: String,
            default: '',
        },
    },
    computed: {
        itemClass() {
            return {
                'check-list-item': true,
                'typographies-paragraph-medium-semibold': true,
                'check-list-item--is-unavailable': !this.available,
                'check-list-item--is-completed': this.completed,
            };
        },
        icon() {
            if (this.completed) {
                return 'success-circle';
            }
            return 'circle';
        },
        isClickable() {
            return this.available && this.redirect_uri;
        },
    },
};
</script>
<style lang="scss" scoped>
.check-list-item {
    align-items: center;
    border: 1px solid var(--colors-common-border-lighter);
    border-radius: var(--spacing-1);
    color: var(--colors-common-text-standard-default);
    cursor: pointer;
    display: flex;
    gap: var(--spacing-1);
    padding: var(--spacing-2) var(--spacing-1);
    transition: border-color 100ms cubic-bezier(0, 0, 0.3, 1);

    &::v-deep {
        .compass-icon {
            color: var(--colors-common-text-standard-caption);
            flex-shrink: 0;
        }

        .compass-flag {
            flex-shrink: 0;
            margin-left: auto;
        }
    }

    &:hover {
        border-color: var(--colors-common-border-default-hover);
    }

    &--is-completed {
        color: var(--colors-common-text-standard-disabled);
        text-decoration: line-through;

        &:hover {
            border-color: var(--colors-common-border-default-hover);
        }

        &::v-deep {
            .compass-icon {
                color: var(--colors-common-text-success-default);
            }
        }
    }

    &--is-unavailable {
        cursor: default;

        &:hover {
            border-color: var(--colors-common-border-lighter);
        }
    }
}
</style>
